<!-- SECTION - Mews -->
<div class="container" id="section-nouvelles" *ngIf="nbNouvelles!=0">
    <img _ngcontent-c6="" class="nouvelles-bg nouvelles-bg-blue" src="assets/img/header/header_mobile_blob_blue.svg">    
    <img class="nouvelles-bg nouvelles-bg-gray" src="assets/img/accueil/nouvelles_bg.svg" />

    <div class="nouvelles-main-container">
        <div class="nouvelles-panel left-panel"><i class="fa fa-arrow fa-arrow-circle-left" [class.on]="posNouvellesStart > 0" (click)="prev()"></i></div>
        <div class="nouvelles-list">
            <div class="nouvelles-row" [ngStyle]="{'left': nouvellesPositionLeft + 'px'}">
                <div class="single-nouvelle" *ngFor="let Nouvelle of listeNouvelles" (swipe)="onSwipe($event)">
                    <div class="nouvelles-image" [ngStyle]="{'background-image': 'url(' + Nouvelle.image + ')'}"></div>
                    <div class="nouvelles-content" *ngIf="currentLang ==='fr'">
                        <div class="nouvelles-date">{{Nouvelle.dateFR}}</div>
                        <div class="nouvelles-title">{{Nouvelle.titreFR}}</div>
                        <div class="nouvelles-text">{{Nouvelle.texteFR}}</div>
                        <div class="nouvelles-read-more"><a [routerLink]="['/nouvelles',Nouvelle.id]">{{ 'accueil.news.lire' | translate }}&nbsp;<i class="fa fa-arrow-right"></i></a></div>
                    </div>
                    <div class="nouvelles-content" *ngIf="currentLang ==='en'">
                            <div class="nouvelles-date">{{Nouvelle.dateEN}}</div>
                            <div class="nouvelles-title">{{Nouvelle.titreEN}}</div>
                            <div class="nouvelles-text">{{Nouvelle.texteEN}}</div>
                            <div class="nouvelles-read-more"><a [routerLink]="['/nouvelles',Nouvelle.id]">{{ 'accueil.news.lire' | translate }}&nbsp;<i class="fa fa-arrow-right"></i></a></div>
                        </div>
                    </div>
            </div>
        </div>
        <div class="nouvelles-panel right-panel"><i class="fa fa-arrow fa-arrow-circle-right" [class.on]="posNouvellesEnd + 1 < nbNouvelles" (click)="next()"></i></div>
    </div>
</div>
<!-- end SECTION - Mews -->
